import {
  ADD_CLIENT_GROUP,
  FETCH_PAGINATED_CLIENT_GROUPS,
  FETCH_ALL_CLIENT_GROUPS,
  UPDATE_CLIENT_GROUP,
  RESET_CLIENT_GROUPS,
} from './../../mutation-types';

export default {
  [ADD_CLIENT_GROUP](state, clientGroup) {
    state.all.push(clientGroup);
  },

  [FETCH_PAGINATED_CLIENT_GROUPS](state, { clientGroups, pagination }) {
    state.items = clientGroups;
    state.pagination = pagination;
  },

  [FETCH_ALL_CLIENT_GROUPS](state, clientGroups) {
    state.all = clientGroups;
  },

  [UPDATE_CLIENT_GROUP]() {
    // shall we update the client group array object here ?
  },

  [RESET_CLIENT_GROUPS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/clientGroup/mutations.js